import {createReducer, on} from '@ngrx/store';
import {ErrorEventEntitiesActions} from './error-event-entities.actions';
import {errorEventEntitiesStateInitial} from './error-event-entities.state.initial';
import {errorEventEntitiesAdapter} from './error-event-entities.adapter';


export const errorEventEntitiesReducers = createReducer(
  errorEventEntitiesStateInitial,

  on(ErrorEventEntitiesActions.loadErrorEvents, (state, {exportConfigId}) => ({
    ...state,
    loadLoading: state.loadLoading.includes(exportConfigId) ? state.loadLoading : [...state.loadLoading, exportConfigId],
  })),

  on(ErrorEventEntitiesActions.loadErrorEventsSuccess, (state, {page, exportConfigId}) =>
    errorEventEntitiesAdapter.setAll(page.content, {
      ...state,
      loadLoading: state.loadLoading.filter(id => id !== exportConfigId),
      loadLoaded: state.loadLoaded.includes(exportConfigId) ? state.loadLoaded : [...state.loadLoaded, exportConfigId],
    })
  ),

  on(ErrorEventEntitiesActions.loadErrorEventsFailure, (state, {exportConfigId}) => ({
    ...state,
    loadLoading: state.loadLoading.filter(id => id !== exportConfigId),
  })),

);
